import { Box, Skeleton, Typography } from '@mui/material';
import { FC } from 'react';

export const ViolationSkeleton: FC = () => {
  return (
    <>
      {[1, 2, 3].map((index) => (
        <Box key={index} sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', gap: '20px', mb: 1 }}>
            <Box sx={{ flexBasis: '65%' }}>
              {/* Header */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Skeleton width="60%" height={24} />
              </Box>

              {/* Description */}
              <Box sx={{ mb: 2 }}>
                <Skeleton width="90%" height={20} />
              </Box>

              {/* Dates section */}
              <Box sx={{ display: 'flex', gap: '20px' }}>
                <Box>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    <Skeleton width={60} />
                  </Typography>
                  <Skeleton width={80} height={24} />
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    <Skeleton width={70} />
                  </Typography>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    <Skeleton width={60} />
                  </Typography>
                  <Skeleton width={80} height={24} />
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    <Skeleton width={70} />
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Actions */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <Box sx={{ alignItems: 'center', gap: 1 }}>
                <Skeleton variant="circular" width={18} height={18} />
                <Skeleton width={40} height={16} />
              </Box>
              <Box sx={{ alignItems: 'center', gap: 1 }}>
                <Skeleton variant="circular" width={18} height={18} />
                <Skeleton width={40} height={16} />
              </Box>
            </Box>
          </Box>

          {index < 3 && <Skeleton variant="rectangular" height={1} sx={{ my: 2 }} />}
        </Box>
      ))}
    </>
  );
};
